import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { ItsmHttpService } from '../../httpServices/itsm-http.service';

@Component({
  selector: 'app-upload-files',
  templateUrl: './upload-files.component.html',
  styleUrls: ['./upload-files.component.scss']
})
export class UploadFilesComponent implements OnInit {

  @Input()
  caseRef: string;

  @Output()
  flagEmitter = new EventEmitter<any>();

  @Input()
  user: string;

  selectedFiles: FileList;
  progressInfos = [];
  message = '';
  maxFileSize = 1024 * 1024 * 250; // 100meg
  uploading = false;

  fileInfos: Observable<any>;

  constructor(
    private translateService: TranslateService,
    private itsmHttpService: ItsmHttpService
  ) { }

  ngOnInit(): void {

  }

  selectFiles(event): void {
    this.progressInfos = [];
    this.selectedFiles = event.target.files;
  }

  upload(idx, file): Promise<void> {
    this.progressInfos[idx] = { value: 0, fileName: file.name };

    return this.itsmHttpService.postCaseAttachement(file, this.caseRef, this.user)
    .then(() => {
      this.progressInfos[idx].value = 100;
    })
    .catch( response => {
      this.message = this.translateService.instant('pages.shared.uploadFailed', { fileName : file.name });
      if (response.error && response.error.code === 2 ) {
        this.message = this.translateService.instant('pages.shared.maliciousContent', { fileName : file.name });
      }
    }).finally(() => {
      this.progressInfos = [];
      this.flagEmitter.emit(this.message);
    });
  }

  /**
   * upload the selected file
   */
  uploadFiles(): void {
    this.message = '';
    this.uploading = true;
    try {
      for (let i = 0; i < this.selectedFiles.length; i++) {
        // initialize values for check process
        const selectedFile = this.selectedFiles[i];
        const sizeCheck = selectedFile.size <= this.maxFileSize;
        const allowedFileType = environment.allowedFileTypes.includes(selectedFile.type);
        const fileCheck = selectedFile.type === '' && selectedFile.name.split('.')[selectedFile.name.split('.').length-1];
        // check file is authorized to be uploaded
        if(sizeCheck && (allowedFileType || (fileCheck === 'p7b') || (fileCheck === 'pcap'))){
          this.upload(i, selectedFile).then(_ => {
            if(i === this.selectedFiles.length - 1) {
              this.uploading = false;
            }
          });
          this.message = this.translateService.instant('pages.shared.uploadControlOK');
        }else{
          this.message = this.translateService.instant('pages.shared.uploadControlKO');
          this.flagEmitter.emit(this.message);
          throw this.message;
        }
      }
    } catch(e) {
      this.uploading = false;
    }
  }

}
